import {
  ref,
} from "vue";

export default function InitOptionsAPI({
  modelColumnsOrderingLocal = ref([]),
  modelColumnsVisible = ref({}),
  saveTableOptions = () => {},
}) {
  const initTableOptions = ({ columnsOrdering = {}, columnsVisible = {} } = {}) => {
    modelColumnsOrderingLocal.value = columnsOrdering.model;
    modelColumnsVisible.value = columnsVisible.model;
    if (columnsOrdering.shouldFix || columnsVisible.shouldFix) {
      saveTableOptions();
    }
  };

  return {
    initTableOptions,
  };
}
